
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[categorySlug]",
      function () {
        return require("private-next-pages/posts/[categorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[categorySlug]"])
      });
    }
  